import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IVoucherFeature } from './voucher.feature.state';
import { VoucherState } from './voucher.state';

export const getVoucherState: MemoizedSelector<IVoucherFeature, VoucherState> = createFeatureSelector<VoucherState>(
  nameof<IVoucherFeature>('VoucherFeature')
);

export const getIsLoading = createSelector(getVoucherState, (state: VoucherState) => state.isLoading);

export const getFailures = createSelector(getVoucherState, (state: VoucherState) => state.failures);

export const getVoucher = createSelector(getVoucherState, (state: VoucherState) => state.voucher);
export const getVoucherAutoApplyResponse = createSelector(getVoucherState, (state: VoucherState) => state.voucherAutoApplyResponse);
export const loyaltyVouchersToApply = createSelector(getVoucherState, (state: VoucherState) => state.loyaltyVouchersToApply);
